/**
 * Filter IDs that are encoded as path segments rather than query params.
 * They are never shown as removable chips and are preserved when clearing filters.
 */
export const PATH_FILTER_IDS = ["finance_type", "monthly_price"];
